export const convertEmbedCodeToReact = (embedCode, setUrl) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(embedCode, "text/html");
  const elements = doc.body.children;

  const convertInlineStylesToReact = (inlineStyle) => {
    const styleObject = {};
    inlineStyle.split(";").forEach((declaration) => {
      if (!declaration.trim()) return;

      const [property, value] = declaration.split(":");
      if (property && value) {
        const camelCaseProperty = property
          .trim()
          .replace(/-([a-z])/g, (_, char) => char.toUpperCase());
        styleObject[camelCaseProperty] = value.trim();
      }
    });
    return styleObject;
  };

  return Array.from(elements).map((el, index) => {
    if (el.tagName.toLowerCase() === "iframe") {
      setUrl(el.getAttribute("src"));
      return (
        <iframe
          key={index}
          src={el.getAttribute("src")}
          width={"100%"}
          height={el.getAttribute("height")}
          scrolling={el.getAttribute("scrolling")}
          frameBorder={el.getAttribute("frameborder")}
          allow={el.getAttribute("allow")}
        />
      );
    }

    const reactStyle = el.getAttribute("style")
      ? convertInlineStylesToReact(el.getAttribute("style"))
      : {};

    return (
      <div key={index} style={reactStyle}>
        {el.innerHTML}
      </div>
    );
  });
};

export const fetchSpotifyDetails = async (spotifyUrl) => {
  const canonicalUrl = spotifyUrl.replace("/embed/", "/");

  const response = await fetch(
    `https://open.spotify.com/oembed?url=${encodeURIComponent(canonicalUrl)}`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch Spotify details");
  }

  const details = await response.json();

  return {
    title: details.title || "",
    image: details.thumbnail_url || null,
  };
};

export const extractSoundCloudTitle = (htmlString) => {
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Find the div and the <a> elements
  const div = doc.querySelector("div");
  const artistAnchor = div.querySelector("a:nth-child(1)");
  const trackAnchor = div.querySelector("a:nth-child(2)");

  if (artistAnchor && trackAnchor) {
    const artist = artistAnchor.title; // Extract artist title
    const track = trackAnchor.title; // Extract track title
    return `${artist} - ${track}`;
  }

  return "Title not found";
};
